/**
 * Copyright (c) 2018-2019 Aleksey Melnikov, True Directive Company.
 * @link https://truedirective.com/
 * @license MIT
*/
import { NgModule, Component, Input, Output, ElementRef, ViewChild,
         EventEmitter, Inject } from '@angular/core';

import { BaseComponent } from './base.component';
import { GridStateService } from './grid-state.service';
import { ColumnType, GridPart } from '@true-directive/base';
import { SortType } from '@true-directive/base';
import { Column } from '@true-directive/base';

@Component({
  selector: 'true-grid-header-cell',
  templateUrl: './grid-header-cell.component.html',
  host: {
    'class': 'true-header-cell'
  },
  styleUrls: ['./styles/grid-header-cell.behavior.scss']
})
export class GridHeaderCellComponent extends BaseComponent {

  @Input('column')
  public column: Column;

  @Output('toggleCheckColumn')
  toggleCheckColumn = new EventEmitter<any>();

  @Output('captionMouseDown')
  captionMouseDown = new EventEmitter<any>();

  @Output('captionMouseUp')
  captionMouseUp = new EventEmitter<any>();

  @Output('captionTouchStart')
  captionTouchStart = new EventEmitter<any>();

  @ViewChild('caption', {static: true})
  caption: any;

  @ViewChild('btn', {static: true})
  btn: any;

  // ÐÐºÐ¾Ð½ÐºÐ° ÑÐ¸Ð»ÑÑÑÐ°
  // ÐÑÐ»Ð¸ ÑÐ¸Ð»ÑÑÑ Ð²ÐºÐ»ÑÑÐµÐ½, ÑÐ¾ Ð¸ÐºÐ¾Ð½ÐºÐ° ÐºÐ½Ð¾Ð¿ÐºÐ¸ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑÑÑ Ð²ÑÐµÐ³Ð´Ð° Ð¸ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¸Ð²Ð°ÐµÑÑÑ
  isFiltered(): boolean {
    return this.state.dataSource.getFilter(this.column) != null;
  }

  public setState(s: string) {
    if (s === 'btn-visible')
      this.caption.nativeElement.classList.toggle('true-grid-btn-visible', true);
  }

  public removeState(s: string) {
    if (s === 'btn-visible')
      this.caption.nativeElement.classList.toggle('true-grid-btn-visible', false);
  }

  btnIconClass() {
    let classes = '';
    if (this.isFiltered()) {
      classes += this.state.sta.filterBtnIconClass_active;
    } else {
      classes += this.state.sta.filterBtnIconClass;
    }
    return classes;
  }

  // ÐÑÑÐ¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð° Ð»Ð¸ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ°
  public isSorted(col: Column): boolean {
    return this.sorted !== null;
  }

  public get sorted(): SortType {
    const res = this.state.dataSource.sortedByField(this.column.fieldName);
    return !res ? null : res.sortType;
  }

  public get sortedUp(): boolean {
    return this.sorted === SortType.ASC;
  }

  public get sortedDown(): boolean {
    return this.sorted === SortType.DESC;
  }

  // ÐÑÐ»Ð¸ Ð¾ÑÑÐ¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½, ÑÐ¾ ÐºÐ°Ðº?..
  sortIndicatorClass() {

    if (this.sortedUp) {
      return this.state.sta.sortedUpIconClass;
    }

    if (this.sortedDown) {
      return this.state.sta.sortedDownIconClass;
    }

    return '';
  }

  toggleCheck(e: any) {
    this.toggleCheckColumn.emit(e);
    e.preventDefault();
  }

  headerMouseDown(e: any) {
    e.stopPropagation();
  }

  mouseDown(e: any) {
    this.captionMouseDown.emit(e);
  }

  mouseUp(e: any) {
    this.captionMouseUp.emit(e);
  }

  touchStart(e: any) {
    this.captionTouchStart.emit(e);
  }

  contextMenu(e: any) {
    this.state.headerContextMenu(e, this.column);
  }

  // ÐÐ»Ð¸Ðº Ð¿Ð¾ ÐºÐ½Ð¾Ð¿ÐºÐµ ÑÐ¸Ð»ÑÑÑÐ°
  btnTouch(e: any) {
    this.state.showFilter(e, this.column);
    e.stopPropagation();
    if (e.cancelable) {
      e.preventDefault();
    }
  }

  // ÐÐ»Ð¸Ðº Ð¿Ð¾ ÐºÐ½Ð¾Ð¿ÐºÐµ ÑÐ¸Ð»ÑÑÑÐ°
  btnClick(e: any) {
    this.state.showFilter(e, this.column);
  }

  // ÐÑÐµÑÑÐ²Ð°ÐµÐ¼ MouseDown, ÑÑÐ¾Ð±Ñ Ð½Ðµ Ð¿ÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð¾ ÑÐ¾ÑÑÐ¸ÑÐ¾Ð²ÐºÐ¸
  btnMouseDown(e: any) {
    e.stopPropagation();
    e.preventDefault();
  }

  ngAfterContentInit() {
    this.addTouchListeners(this.caption.nativeElement);
  }

  constructor(
    @Inject('gridState') public state: GridStateService,
    public elementRef: ElementRef) {
      super();
    }
}
